import type { PropertyData, BuyerCriteria } from './matchingScoreEngine';

export type ConfidenceLevel = 'high' | 'medium' | 'low';

export interface ConfidenceResult {
  level: ConfidenceLevel;
  label: string;
  percentage: number;
}

const BUYER_SIGNALS = [
  'priceMin',
  'priceMax',
  'cities',
  'rooms',
  'propertyTypes',
  'minSize',
  'maxSize',
] as const;

const PROPERTY_SIGNALS = [
  'price',
  'city',
  'rooms',
  'propertyType',
  'size',
] as const;

function hasValue(obj: Record<string, unknown>, key: string): boolean {
  const v = obj[key];
  if (v === undefined || v === null) return false;
  if (typeof v === 'string') return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

export function calculateConfidence(
  property: PropertyData,
  criteria: BuyerCriteria,
): ConfidenceResult {
  const buyerObj = criteria as unknown as Record<string, unknown>;
  const propObj = property as unknown as Record<string, unknown>;

  const buyerFilled = BUYER_SIGNALS.filter(k => hasValue(buyerObj, k)).length;
  const propFilled = PROPERTY_SIGNALS.filter(k => hasValue(propObj, k)).length;

  const total = BUYER_SIGNALS.length + PROPERTY_SIGNALS.length;
  const filled = buyerFilled + propFilled;
  const percentage = Math.round((filled / total) * 100);

  let level: ConfidenceLevel;
  if (percentage >= 80) level = 'high';
  else if (percentage >= 50) level = 'medium';
  else level = 'low';

  const labelMap: Record<ConfidenceLevel, string> = {
    high: 'גבוהה',
    medium: 'בינונית',
    low: 'נמוכה',
  };

  return { level, label: labelMap[level], percentage };
}
